import storeModuleCreators from '../../utils/store';
import ReportRepository from '../../repositories/Admin/ReportRepository';

const { createShowActionStoreModule } = storeModuleCreators;

export const { slice, selectors, useActions } = createShowActionStoreModule({
  slicePath: ['admin', 'reports', 'transactionsData'],
  repositoryAction: ReportRepository.getTransactionsData,
});

export default slice.reducer;
